import axios from "axios";
import { createContext, useState, useEffect } from "react";

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [isLoggin, setIsLoggin] = useState(false);
    const token = localStorage.getItem("token") || "";

    useEffect(() => {
        const fetchUser = async () => {
            const API = process.env.REACT_APP_BACKEND_URL;
            if (!token) return; // Skip if no token is found

            try {
                const response = await axios.get(`${API}/auth`, {
                    headers: {
                        "Authorization": `Bearer ${token}`
                    }
                });

                setUser(response.data);
                setIsLoggin(true);                
            } catch (error) {
                console.error("Failed to fetch user data:", error.response?.data?.message || error.message);
                setIsLoggin(false);
                setUser(null);
            }
        };
 
        fetchUser();
    }, [token]); // Run only once on mount

    return (
        <AuthContext.Provider value={{ user, setUser, token, isLoggin, setIsLoggin }}>
            {children}
        </AuthContext.Provider>
    );
};